import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "./AppLayout";

const Scoreboard = lazy(() => import("../Pages/Scoreboard"));
const Scoreboard2 = lazy(() => import("../Pages/Scoreboard2"));
const Scoreboard3 = lazy(() => import("../Pages/Scoreboard3/index"));
const Scoreboard4 = lazy(() => import("../Pages/Scoreboard4/index"));
const Scoreboard5 = lazy(() => import("../Pages/Scoreboard5/index"));
const Scoreboard6 = lazy(() => import("../Pages/Scoreboard6/index"));
const Scoreboard7 = lazy(() => import("../Pages/Scoreboard7/index"));
const VirtualScoreCard = lazy(() => import("../Pages/VirtualScoreCard"));
const VirtualGround = lazy(() => import("../Pages/VirtualGround/VirtualGround"));
const CardCricket = lazy(() => import("../Pages/CricketCard"));

const PublicRoutes = () => {
  return (
    <BrowserRouter>
      <AppLayout>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/scoreboard" element={<Scoreboard />} />
            <Route path="/virtualCard" element={<VirtualScoreCard />} />
            <Route path="/scoreboard2" element={<Scoreboard2 />} />
            <Route path="/scoreboard3" element={<Scoreboard3 />} />
            <Route path="/scoreboard4" element={<Scoreboard4 />} />
            <Route path="/scoreboard5" element={<Scoreboard5 />} />
            <Route path="/scoreboard6" element={<Scoreboard6 />} />
            <Route path="/scoreboard7" element={<Scoreboard7 />} />
            <Route path="/virtualGround" element={<VirtualGround />} />
            <Route path="/cardscoreboard" element={<CardCricket />} />
          </Routes>
        </Suspense>
      </AppLayout>
    </BrowserRouter>
  );
};

export default PublicRoutes;
